<template>
    <div class="popup popup--vue" v-bind:class="{'is-active': show}">
        <div class="popup__content">

            <div class="popup__header popup__header--narrow">
                <div class="title-3">{{ $t('watchDog.form.title') }}</div>
                <button class="popup__close js-popup-close" @click.prevent.stop="cancel" aria-label="{{ button }}"></button>
            </div>

            <div class="popup__body py-5">
                <div class="text-center pb-md-5 description">{{ $t('watchDog.popupInfo') }}</div>
                <div class="row justify-content-center">
                <form action="#" ref="form" class="mt-3 col-md-4" @submit="submitForm">

                    <label  class="custom-formField--input">
                        <span>{{ $t('watchDog.form.emailPlacehodler') }}</span>
                        <input type="email"
                               name="watch-dog-email"
                               v-model="formInputWatchDogEmail"
                               >
                    </label>

                    <div class="text-center">
                        <input class="btn btn--cta btn--popup" type="submit" :value="$t('watchDog.form.submit')">
                    </div>

                    <div v-if="formErrors.length" class="mt-3">
                        <b class="red">{{ $t('watchDog.form.errors') }}</b>
                        <ul class="mt-1">
                            <li v-for="formError in formErrors">{{ formError }}</li>
                        </ul>
                    </div>
                </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from "axios";

export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        title: {},
        button: {
            type: String,
        },
        variantId: {}
    },
    data: function () {
        return {
            formErrors: [],
            formInputWatchDogEmail: ''
        };
    },
    watch: {
        show: function (newVal) {
                if(newVal) {
                    disable_scroll();
                } else {
                    enable_scroll();
                }
        }
    },
    methods: {
        cancel() {
            this.$emit('cancel');
        },
        sendForm(e) {
            let data = new FormData();
            data.set("variantId", this.variantId);
            data.set("watchDogEmail", this.formInputWatchDogEmail);

            let that = this;

            that.$refs.form.classList.add('loading');

            Axios.post(URLSource.ajaxAddWatchDogConfiguratorData, data)
                .then(function (response) {
                    if (response.data.result === 'ok') {



                        setTimeout(function () {
                            that.$refs.form.classList.remove('loading');
                        }, 500);

                        setTimeout(function () {
                            that.cancel();
                        }, 700);

                    } else {

                        that.$refs.form.classList.add('failmark');
                        setTimeout(function () {
                            that.$refs.form.classList.remove('failmark');
                        }, 2000);
                    }
                });

            e.preventDefault();
        },
        submitForm: function (e) {
            this.formErrors = [];

            if (!this.formInputWatchDogEmail) {
                this.formErrors.push(this.$t('watchDog.form.error.watchDogEmailReq'));
            } else if (!this.validEmail(this.formInputWatchDogEmail)) {
                this.formErrors.push(this.$t('watchDog.form.error.watchDogEmailReqIsNotValid'));
            }

            if (!this.formErrors.length) {
                this.sendForm(e);
                return true;
            }

            e.preventDefault();
        },
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
    }
};
</script>
